/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./file-meta.vue?vue&type=template&id=5365ecd1&scoped=true&"
import script from "./file-meta.vue?vue&type=script&lang=js&"
export * from "./file-meta.vue?vue&type=script&lang=js&"
import style0 from "./file-meta.vue?vue&type=style&index=0&id=5365ecd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365ecd1",
  null
  
)

export default component.exports